/* eslint-disable no-underscore-dangle */
export default class UrlPrefixer {
	constructor({ elements }) {
		this._elements = elements;
		this._pattern = /^(https?:\/\/)/;
		if (this._elements && this._elements.length > 0) {
			this._elements.forEach((element) => {
				element.addEventListener('blur', (e) => this.checkProtocol(e));
			});
		}
	}

	checkProtocol(event) {
		this.target = event.target;
		if (this.target && this.target.value) {
			if (this._pattern.test(this.target.value)) {
				return true;
			}
			return this.setProtocol(this.target);
		}
		return false;
	}

	setProtocol() {
		this.target.value = `https://${this.target.value}`;
	}
}
